import React, { useRef, useState } from "react";
import { sendEnquiry } from "../../services/email.service";

interface IContactFormComponentProps {}

export const ContactFormComponent: React.FC<
    IContactFormComponentProps
> = () => {
    const form = useRef<HTMLFormElement>(null);
    const [loading, setLoading] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [phoneNumber, setPhoneNumber] = useState("");

    const handlePhoneNumberChange = (
        e: React.ChangeEvent<HTMLInputElement>,
    ) => {
        const value = e.target.value;
        // Allow only digits and max 10 characters
        if (/^\d*$/.test(value) && value.length <= 10) {
            setPhoneNumber(value);
        }
    };

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();

        if (form.current) {
            setLoading(true);
            try {
                await sendEnquiry(form.current);
                setSuccessMessage("Enquiry Sent Successfully.");
                form.current.reset();
                setPhoneNumber("");
                setTimeout(() => setSuccessMessage(""), 3000);
            } catch (error) {
                setErrorMessage(
                    "Something went wrong. Please try again later.",
                );
                setTimeout(() => setErrorMessage(""), 3000);
            } finally {
                setLoading(false);
            }
        }
    };

    return (
        <form
            ref={form}
            onSubmit={handleSubmit}
            className="php-email-form"
            data-aos="fade-up"
            data-aos-delay="200"
        >
            <div className="row gy-4">
                <div className="col-md-6">
                    <input
                        type="text"
                        name="name"
                        className="form-control"
                        placeholder="Your Name*"
                        required
                    />
                </div>

                <div className="col-md-6">
                    <input
                        type="email"
                        name="email"
                        className="form-control"
                        placeholder="Your Email*"
                        required
                    />
                </div>

                {/* Subject and Phone side-by-side */}
                <div className="col-md-6">
                    <input
                        type="text"
                        name="subject"
                        className="form-control"
                        placeholder="Subject*"
                        required
                    />
                </div>

                <div className="col-md-6">
                    <input
                        type="text"
                        name="phoneNumber"
                        className="form-control"
                        placeholder="Phone Number*"
                        inputMode="numeric"
                        value={phoneNumber}
                        onChange={handlePhoneNumberChange}
                        required
                    />
                </div>

                <div className="col-md-12">
                    <textarea
                        className="form-control"
                        name="message"
                        placeholder="Message*"
                        required
                        style={{ resize: "none" }}
                    ></textarea>
                </div>

                {successMessage && (
                    <div className="mt-3" style={{ color: "green" }}>
                        {successMessage}
                    </div>
                )}
                {errorMessage && (
                    <div className="mt-3 text-center" style={{ color: "red" }}>
                        {errorMessage}
                    </div>
                )}

                <div className="col-md-12 text-center">
                    <button
                        type="submit"
                        className="btn btn-primary gradient-bg"
                        style={{ width: "200px" }}
                        disabled={loading}
                    >
                        {loading ? (
                            <div
                                className="spinner-border spinner-border-sm text-white"
                                role="status"
                            >
                                <span className="visually-hidden">
                                    Loading...
                                </span>
                            </div>
                        ) : (
                            "Send Message"
                        )}
                    </button>
                </div>
            </div>
        </form>
    );
};
